<template>
<!--컨텐츠-->
	<div class="contents contents--full">
		<div class="contents__wrap">

			<!--페이지 상단-->
			<div class="sub-top">
				<h3>기관별 평가진행 리스트</h3>
				<div class="sub-top__navi">
					<span class="icon-home navi--home"></span>
					<span>기관 평가하기</span>
				</div>
			</div>
			<!--검색박스-->
			<div class="searchbox spacing--xs">
				<div class="searchbox__box">
					<div class="searchbox__frame">
						<div class="searchbox__input">
							<div class="input-btn">
								<input type="text" placeholder="기관명을 입력해주세요" v-model="searchText" @keyup.enter="gridLoad">
								<button type="button" @click="gridLoad" class="btn btn--primary btn--icon icon-search"></button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="table__wrap spacing--xxxs">
				<table class="table table--split" style="min-width:768px;">
					<tr>
						<th>기관명</th>
						<th>내부통제체계 진단 현황</th>
						<!-- <th>상태</th>
						<th>담당자 이메일</th>
						<th>관리</th> -->
					</tr>
					<tr v-for="(vo, index) of evalList" :key="index" >
						<td>{{vo.organizationName}}</td>
						<td>
							
							<button 
							type="button" 
							class="btn btn--secondary btn--outline btn--xs" 
							@click="goDetail(vo.organizationCode, vo.organizationName)">
							평가하기
							</button>

						</td>
					</tr>
				</table>
			</div>

			<!--페이징-->
		<Pagination v-if="orgJson.pagination" :gridInfo="orgJson" @getGridData="getGridData" @click="goPage()" />
		</div>
	</div>
</template>
   
<script setup>
import { useStore } from 'vuex'
import { ref, computed, onMounted, onUnmounted ,watch} from 'vue'
import orgJson from '@/models/gridInfo/org.json'
import Pagination from '@/components/common/grid/pagination.vue'
import { useRouter } from 'vue-router'
import { updateOrgState,deleteOrg,sendAdminMail } from '@/api/org'
import { insertPermissions,selectPermissions } from '@/api/eval'

const store = useStore()
const router = useRouter()
const isLoading = ref(false) // 로딩 상태 변수 추가

const searchText = ref('')
const searchCode = ref('all')
const checkUserId = computed(() => store.state.temp.userInfo )


const orgList = computed(() => {
	return store.state.grid.orgData
})

const searchParam = computed(() => {
	return store.state.temp.searchParam 
})

const goPage = () => {
	console.log("searchParam.value.pageNo : " + searchParam.value.pageNo)
	// localStorage.setItem('searPageNo', searchParam.value.pageNo);
};

const goDetail = (orgCode,orgName) => {
	router.push({
		name :'organizationView',
		query : {
			organizationCode : orgCode,
			organizationName : orgName
		}
	})
}

const gridLoad = () => {
	store.commit('temp/setSearchParam', {key : 'pageNo', value : 1})
	store.commit('temp/setSearchParam', {key : 'searchCode', value:searchCode.value})
	store.commit('temp/setSearchParam', {key : 'searchText', value:searchText.value})
	getEvalData()
}

const getGridData = async () => {
	let param = {
		pageNo : searchParam.value.pageNo,
		countPerRecord : searchParam.value.countPerRecord,
		search : searchText.value,
		typeCd : searchCode.value
	}
	console.log()
	await store.dispatch('grid/fetchOrgVue', param)
}

const evalList = ref([]) // 메인 그리

const getEvalData = async () => {
  let param = {
		memberCode : checkUserId.value.memberCode,
		organizationName : searchText.value
	}
	const rtn = await selectPermissions(param);

  if (rtn?.result === 'ok' && Array.isArray(rtn.data)) {
      // 그대로 table에 바인딩
      evalList.value = rtn.data.map(item => ({
        organizationCode: item.organizationCode,
		organizationName: item.organizationName
      }));

    } else {
      evalList.value = [];
    }
};


onMounted(async () => {
	console.log("맴버 코드 확인" ,checkUserId.value.memberCode)
	searchCode.value = searchParam.value.searchCode || 'all'
	searchText.value = searchParam.value.searchText
	await getEvalData()
})

onUnmounted(() => {
	store.commit('temp/clearSearchParam')
	// 페이지 닫힐 때 해당 리스너 삭제
	
}) 

</script>

<style scoped>
	.loading-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
		color: white;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		z-index: 1000;
	}
	
	.spinner {
		border: 5px solid rgba(255, 255, 255, 0.3);
		border-top: 5px solid white;
		border-radius: 50%;
		width: 50px;
		height: 50px;
		animation: spin 1s linear infinite;
	}
	
	@keyframes spin {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}
	.red-dot-container {
  display: flex; /* 레드닷과 버튼을 가로로 배치 */
  align-items: center; /* 수직 정렬 */
  margin-left: 8px; /* 왼쪽으로 8px 이동 */
}

.red-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 50%;
  margin-right: 8px; /* 버튼과 간격 추가 */
}

.red-dot-placeholder {
  display: inline-block;
  width: 10px; /* 레드닷과 동일한 너비 */
  height: 10px; /* 레드닷과 동일한 높이 */
  margin-right: 8px; /* 버튼과 간격 추가 */
}

</style>